if (!customElements.get('ryvo-buyer-navigation')) {
  customElements.define('ryvo-buyer-navigation', class extends HTMLElement {
    connectedCallback() {
      this.onToggle = (event) => {
        const opened = event.target;
        if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
        for (const other of this.querySelectorAll('details[open]')) {
          if (other !== opened) other.open = false;
        }
      };
      this.onKeydown = (event) => {
        if (event.key !== 'Escape') return;
        const opened = this.querySelector('details[open]');
        if (!opened) return;
        opened.open = false;
        opened.querySelector('summary')?.focus();
        event.preventDefault();
      };
      this.onOutside = (event) => {
        if (this.contains(event.target)) return;
        for (const opened of this.querySelectorAll('details[open]')) opened.open = false;
      };
      this.addEventListener('toggle', this.onToggle, true);
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onOutside);
    }
    disconnectedCallback() {
      this.removeEventListener('toggle', this.onToggle, true);
      this.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('click', this.onOutside);
    }
  });
}
